<template>
	<div class="student-list">
		<!-- 搜索框 -->
		<div class="search flex between">
			<input v-model="queryParam" maxlength="20" type="text" placeholder="搜索" />
			<img @click="getMemberList" src="@img/icon/ui_search.png" alt="">
		</div>

		<!-- 教师 -->
		<p class="flex">
			教师
			<span>（{{members.teachers?.length}}人）</span>
		</p>
		<div v-if="members.teachers?.length===0" class="nodata"></div>
		<div v-for="(item,index) in members.teachers" :key="`teacher${index}`" class="card flex">
			<img :src="item.headPortrait||avatar" alt />
			<span>{{item.name}}</span>
		</div>
		<!-- 学生 -->
		<p class="flex">
			学生
			<span>（{{members.students?.length}}人）</span>
		</p>
		<div v-if="members.students?.length===0" class="nodata"></div>
		<div v-for="(item,index) in members.students" :key="`student${index}`" class="student card flex start">
			<img :src="item.headPortrait||avatar" alt />
			<div class="flex between-v">
				<span>{{item.name}}</span>
				<span>学号：{{item.number}}</span>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			avatar: require("@img/avatar_girl.png"),
			queryParam: undefined,
			members: {
				teachers: [],
				students: [],
			},
		};
	},

	mounted() {
		this.getMemberList();
	},

	methods: {
		async getMemberList() {
			try {
				const {success,message,result} = await this.$http.get(`h5/general/listTeamUser?teamId=${this.$route.query.gradeId}&query=${this.queryParam||''}`);
				if (!success) throw new Error(message);
				this.members = result;
			} catch (error) {
				console.log("getMemberList", error);
			}
		},
	},
};
</script>


<style lang="less" scoped>
.student-list {
	padding: 0 17 / @rem 10 / @rem;
	.search {
		width: 100%;
		position: relative;
		input {
			padding: 0 50 / @rem 0 30 / @rem;
			width: 100%;
			height: 42 / @rem;
			font-size: 14 / @rem;
			border-radius: 21 / @rem;
			background-color: #f3f3f3;
			&::placeholder {
				color: rgba(23, 24, 25, 0.2);
			}
		}
		img{
			position: absolute;
			right: 20 / @rem;
			width: 19 / @rem;
			height: 19 / @rem;
		}
	}
	p {
		padding: 12 / @rem 0;
		font-size: 25 / @rem;
		color: #8f4d00;
		font-weight: bold;
		font-family: Source Han Sans CN-Bold, Source Han Sans CN;
		span {
			font-size: 14px;
			color: rgba(143, 77, 0, 0.3);
			font-weight: 400;
			font-family: Source Han Sans CN-Medium, Source Han Sans CN;
		}
	}

	.card {
		padding: 12 / @rem 0;
		img {
			width: 59 / @rem;
			height: 59 / @rem;
			object-fit: contain;
			border-radius: 50%;
		}
		span {
			padding-left: 16 / @rem;
			color: #000000;
			font-weight: bold;
			font-family: Source Han Sans CN-Medium, Source Han Sans CN;
		}
		&.student {
			> div {
				flex: 1;
				align-items: flex-start;
				span:last-child {
					padding-top: 5 / @rem;
					font-size: 13 / @rem;
					font-weight: 400;
					color: rgba(31, 30, 29, 0.6);
				}
			}
		}
	}
}
</style>
